export default __webpack_public_path__ + "static/media/new-feature-condition-explorer.71450feb.svg";